import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/content/home/index.vue";
import Solution from "@/components/content/solution/solution";
import Product from "@/components/content/product/product";
import Contact from "@/components/content/contactUs/contactUs";
import Check from "@/views/check/index.vue";
import Check2 from "@/views/check2/index.vue";
import Test from "@/views/test/index.vue";
import Feature from "@/views/feature/index.vue";
import AboutUs from "@/views/aboutUs/index.vue";
import CheckCenter from "@/views/checkCenter/index.vue";
import DocumentCenter from "@/views/documentCenter/index.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: Home,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/Solution",
      name: "Solution",
      component: Solution,
    },
    {
      path: "/product",
      name: "product",
      component: Product,
    },
    {
      path: "/contactUs",
      name: "contactUs",
      component: Contact,
    },
    {
      path: "/check",
      name: "check",
      component: Check,
    },
    {
      path: "/Check2",
      name: "Check2",
      component: Check2,
    },
    {
      path: "/checkCenter",
      name: "checkCenter",
      component: CheckCenter,
    },
    {
      path: "/documentCenter",
      name: "documentCenter",
      component: DocumentCenter,
    },
    {
      path: "/test",
      name: "test",
      component: Test,
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: AboutUs,
    },
    {
      path: "/feature",
      name: "feature",
      component: Feature,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js